import * as React from "react";
import { TagLabel } from "@draftkings/arena-web";
export const InelligibleForBonusBadge = React.memo(function InelligibleForBonusBadge(props) {
    const { dictionary, testId } = props;
    return (React.createElement(TagLabel, { testId: testId, variant: "boostInelligible" }, dictionary.myBetsDictionary.BonusIneligibleLabel));
});
//# sourceMappingURL=InelligibleForBonusBadge.js.map